





















































import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import { getRuleList } from '../api';

Vue.use(List);

@Component
export default class News extends Vue {
  show: boolean = true;
  imgList: any = [
    {
      url: require('../assets/进行中.png'),
    },
    {
      url: require('../assets/已结束.png'),
    },
    {
      url: require('../assets/即将开始.png'),
    },
  ];
  list: any = [
    {
      text: '网络互动类',
      img: require('../assets/网络互动类.png'),
      id: 1,
    },
    {
      text: '展示体验类',
      img: require('../assets/展示体验类.png'),
      id: 2,
    },
    {
      text: '文化传播类',
      img: require('../assets/文化传播类.png'),
      id: 3,
    },
    {
      text: '比赛竞技类',
      img: require('../assets/比赛竞技类.png'),
      id: 4,
    },
    {
      text: '讲座沙龙类',
      img: require('../assets/讲座沙龙类.png'),

      id: 5,
    },
  ];
  tab: any = [];
  text: string = '';
  a: number = 0;
  async goText(text: any) {
    this.show = false;
    const res: any = await getRuleList(text);
    this.tab = res.data;
  }
  tabs(id: any) {
    this.$router.push(`text?id=${id}`);
  }
}
